
import { mapStores } from 'pinia';
import { defineComponent } from 'vue';
import { FormRules, NAlert, NButton, NForm, NFormItem, NInput, NSpin } from 'naive-ui';

import { useAuthStore } from '~/store/auth.store';

export default defineComponent({
    components: {
        NButton,
        NInput,
        NForm,
        NFormItem,
        NAlert,
        NSpin,
    },

    data() {
        return {
            result: {
                email: '',
            },
            messages: {
                required: this.$t('reset_password.form.required'),
            },
            rules: {
                email: { required: true, trigger: ['submit']},
            } as FormRules,
            failed: false,

            loading:false,
            success: false,
            error: false,
        };
    },

    computed: {
        ...mapStores(useAuthStore),
        logo() {
            return require('./../../../img/avolta-connect-logo.png').default
        },
        userImg() {
            return require('./../../../img/profile-pic.png').default
        }
    },

    methods: {
        onSubmit(e: Event) {
            e.preventDefault();
            this.error = false;
            this.loading = true;
            this.authStore.forgotPassword(this.result?.email)
                .then(() => {
                    this.success = true;
                })
                .catch(() => {
                    this.error = true;
                })
                .finally(() => {
                    this.loading = false;
                });
        },
    },

    watch: {
        result: {
            handler() {
                //@ts-ignore
                this.$refs?.form?.validate((errors) => {
                    this.valid = !errors;
                })
                .catch((err: Error) => {
                    this.er
                    if (err) {
                            this.valid = false;
                    }
                });
            },
            deep: true,
        }
    }
});